<script>import { onMount, afterUpdate, beforeUpdate } from "svelte";
import { throttle } from "../util/util.js";
export let viewBox = void 0;
export let tag = void 0;
export let bounds = void 0;
const updateSize = () => {
  const currentBounds = svgNode.getBoundingClientRect();
  if (bounds === void 0 || bounds.width !== currentBounds.width || bounds.height !== currentBounds.height) {
    bounds = currentBounds;
  }
};
$:
  viewBoxAttrib = viewBox && viewBox.length >= 2 ? viewBox.length >= 4 ? viewBox.slice(0, 4).join(" ") : `0 0 ${viewBox.slice(0, 2).join(" ")}` : "0 0 0 0";
let svgNode;
onMount(() => {
  window.requestAnimationFrame(updateSize);
});
beforeUpdate(() => {
  if (svgNode) {
    updateSize();
  }
});
</script>

<svelte:window on:resize={throttle(updateSize,100)} />

<svg bind:this={svgNode} class={tag ?? ''} viewBox={viewBoxAttrib} width="100%" height="100%">
    <slot/>
</svg>